import { isSkuAvailable } from '../constants/quarterConfig';

/**
 * Single source of truth for product option visibility. Each option declares its
 * own gating metadata; cards encode no policy of their own.
 *
 * @param {Array} options - Array of product option mappings
 * @param {Object} ctx
 * @param {boolean} ctx.hasSpecialAccess - User has special/admin access
 * @param {string} ctx.quarter - Current delivery quarter
 * @returns {Array} Options visible to this user, this quarter
 *
 * Option gating fields (all optional):
 *   enabled: false  -> hard kill-switch, hidden from everyone (replaces commenting out)
 *   adminOnly: true -> requires hasSpecialAccess
 *   availableFrom   -> quarter gate ("YYYY-Qn")
 * Absence of all three = visible to everyone, now.
 */
export const getVisibleOptions = (options = [], { hasSpecialAccess, quarter } = {}) =>
  (options || []).filter(opt => {
    if (opt.enabled === false) return false;                       // hard kill-switch
    if (opt.adminOnly && !hasSpecialAccess) return false;          // access gate
    if (!isSkuAvailable(opt.availableFrom, quarter)) return false; // quarter gate
    return true;
  });

/**
 * Find current mapping from filtered list by part number or capacity
 * @param {Array} filteredMappings - Already filtered mappings
 * @param {string|number} currentPartNumber - Current selected part number
 * @param {number} currentCapacity - Current selected capacity (fallback)
 * @returns {Object|null} Found mapping or first available
 */
export const findCurrentMapping = (filteredMappings, currentPartNumber, currentCapacity) => {
  return filteredMappings.find(m => m.partNumber === currentPartNumber) ||
         filteredMappings.find(m => m.capacity === currentCapacity) ||
         filteredMappings[0] ||
         null;
};